import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeTypeForm from '../../../components/forms/RangeTypeForm';
import { useCreateRangeType } from '../../../hooks/useRangeTypeApi';
import { useNavigate } from 'react-router-dom';
import { RangeTypeDTO } from '../../../services/apiClient';

const RangeTypeCreate: React.FC = () => {
  const createMutation = useCreateRangeType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Range Types', href: '/admin/rangetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: RangeTypeDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/rangetypes');
    } catch (error) {
      console.error('Error creating RangeType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rangetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.RangeType.Edit"
    >
      <RangeTypeForm
        initialValues={{} as RangeTypeDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/rangetypes')}
      />
    </AdminLayout>
  );
};

export default RangeTypeCreate;
